import {request} from '../utils/request'
import {functionApi} from "../config/urlConfig"
/**
 * 调用大函数，并获取返回值
 */
export const callMaxFunctionWithReturnVal = (data: any, headers?: any) =>
  request({
    url: `${functionApi}/businessRule/callMaxFunctionWithReturnVal`,
    method: 'post',
    data,
    headers
  })

export const pageQueryResult = (data: any, headers?: any) =>
  request({
    url: `${functionApi}/businessRule/pageQueryResult`,
    method: 'post',
    data,
    headers
  })


export const apiDataResultMapping = (data: any, headers?: any) =>
  request({
    url: `${functionApi}/funDesign/apiDataResultMapping`,
    method: 'post',
    data,
    headers
  })
